import * as yup from 'yup';
import { CreateRoleFormValues } from './types';

const NAME_PATTERN = /^[a-zA-Z0-9_-]+$/;
const DESCRIPTION_PATTERN = /^[a-zA-Z0-9 _.,-]+$/;

export const createRoleValidationSchema: yup.ObjectSchema<CreateRoleFormValues> =
  yup.object({
    name: yup
      .string()
      .required('Name is required')
      .min(3, 'Name must be at least 3 characters')
      .max(50, 'Name must be at most 50 characters')
      .matches(
        NAME_PATTERN,
        'Name may only contain letters, numbers, hyphens, and underscores',
      ),
    description: yup
      .string()
      .default('')
      .test(
        'description-format',
        'Description may only contain letters, numbers, spaces, hyphens, underscores, commas, and dots',
        value => {
          if (!value) return true;
          return DESCRIPTION_PATTERN.test(value);
        },
      )
      .test(
        'description-length',
        'Description must be between 3 and 250 characters',
        value => {
          if (!value) return true;
          return value.length >= 3 && value.length <= 250;
        },
      ),
    teamId: yup.string().required('Team is required'),
    contents: yup
      .array()
      .of(yup.string().required())
      .default([])
      .min(1, 'Select at least one role or attribute'),
  });

export const DEFAULT_CREATE_ROLE_VALUES: CreateRoleFormValues = {
  name: '',
  description: '',
  teamId: '',
  contents: [],
};
